import { RouterProvider } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { router } from './routes/router';
import { queryClient } from './lib/react-query';
import { SnackbarProvider } from './providers/SnackbarProvider';
import BackendConnectionBanner from './components/common/BackendConnectionBanner';
import { useBackendHealth } from './hooks/useBackendHealth';
import ErrorBoundary from './components/common/ErrorBoundary';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { ActiveRunProvider } from './contexts/ActiveRunContext';
import NetworkStatusBanner from './components/common/NetworkStatusBanner';
import PerformanceMonitor from './components/common/PerformanceMonitor';

export default function App() {
  const { isConnected, isChecking, retry } = useBackendHealth();

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ThemeProvider>
            <CssBaseline />
            <NetworkStatusBanner />
            <PerformanceMonitor />
            {!isConnected && <BackendConnectionBanner onRetry={retry} isRetrying={isChecking} />}
            <SnackbarProvider>
              <ActiveRunProvider>
                <RouterProvider router={router} />
              </ActiveRunProvider>
            </SnackbarProvider>
          </ThemeProvider>
        </AuthProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
